import React from "react";

const Stat_Hyp_Testing_Proportion = () => {
  return (
    <div>
      <h1>Stat Hyp. Testing Proportion</h1>
    </div>
  );
};

export default Stat_Hyp_Testing_Proportion;
